"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.noRecords = 'grid.noRecords';
/**
 * @hidden
 */
exports.pagerInfo = 'grid.pagerInfo';
/**
 * @hidden
 */
exports.pagerFirstPage = 'grid.pagerFirstPage';
/**
 * @hidden
 */
exports.pagerPreviousPage = 'grid.pagerPreviousPage';
/**
 * @hidden
 */
exports.pagerNextPage = 'grid.pagerNextPage';
/**
 * @hidden
 */
exports.pagerLastPage = 'grid.pagerLastPage';
/**
 * @hidden
 */
exports.pagerItemPerPage = 'grid.pagerItemsPerPage';
/**
 * @hidden
 */
exports.pagerPage = 'grid.pagerPage';
/**
 * @hidden
 */
exports.pagerOf = 'grid.pagerOf';
/**
 * @hidden
 */
exports.pagerTotalPages = 'grid.pagerTotalPages';
/**
 * @hidden
 */
exports.groupPanelEmpty = 'grid.groupPanelEmpty';
/**
 * @hidden
 */
exports.filterClearButton = 'grid.filterClearButton';
/**
 * @hidden
 */
exports.filterSubmitButton = 'grid.filterSubmitButton';
/**
 * @hidden
 */
exports.filterTitle = 'grid.filterTitle';
/**
 * @hidden
 */
exports.sortAscending = 'grid.sortAscending';
/**
 * @hidden
 */
exports.sortDescending = 'grid.sortDescending';
/**
 * @hidden
 */
exports.searchPlaceholder = 'grid.searchPlaceholder';
/**
 * @hidden
 */
exports.filterCheckAll = 'grid.filterCheckAll';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.noRecords] = 'No records available',
    _a[exports.groupPanelEmpty] = 'Drag a column header and drop it here to group by that column',
    _a[exports.filterClearButton] = 'Clear',
    _a[exports.filterSubmitButton] = 'Filter',
    _a[exports.filterTitle] = 'Filter',
    _a[exports.sortAscending] = 'Sort Ascending',
    _a[exports.sortDescending] = 'Sort Descending',
    _a[exports.pagerItemPerPage] = 'items per page',
    _a[exports.pagerInfo] = '{0} - {1} of {2} items',
    _a[exports.pagerFirstPage] = 'Go to the first page',
    _a[exports.pagerPreviousPage] = 'Go to the previous page',
    _a[exports.pagerNextPage] = 'Go to the next page',
    _a[exports.pagerLastPage] = 'Go to the last page',
    _a[exports.pagerPage] = 'Page',
    _a[exports.pagerOf] = 'of',
    _a[exports.pagerTotalPages] = '{0}',
    _a[exports.searchPlaceholder] = 'Search',
    _a[exports.filterCheckAll] = 'Check All',
    _a['grid.filterEqOperator'] = 'Is equal to',
    _a['grid.filterNotEqOperator'] = 'Is not equal to',
    _a['grid.filterIsNullOperator'] = 'Is null',
    _a['grid.filterIsNotNullOperator'] = 'Is not null',
    _a['grid.filterIsEmptyOperator'] = 'Is empty',
    _a['grid.filterIsNotEmptyOperator'] = 'Is not empty',
    _a['grid.filterStartsWithOperator'] = 'Starts with',
    _a['grid.filterContainsOperator'] = 'Contains',
    _a['grid.filterNotContainsOperator'] = 'Does not contain',
    _a['grid.filterEndsWithOperator'] = 'Ends with',
    _a['grid.filterGteOperator'] = 'Is greater than or equal to',
    _a['grid.filterGtOperator'] = 'Is greater than',
    _a['grid.filterLteOperator'] = 'Is less than or equal to',
    _a['grid.filterLtOperator'] = 'Is less than',
    _a['grid.filterIsTrue'] = 'Is true',
    _a['grid.filterIsFalse'] = 'Is false',
    _a['grid.filterBooleanAll'] = '(All)',
    _a['grid.filterAfterOrEqualOperator'] = 'Is after or equal to',
    _a['grid.filterAfterOperator'] = 'Is after',
    _a['grid.filterBeforeOperator'] = 'Is before',
    _a['grid.filterBeforeOrEqualOperator'] = 'Is before or equal to',
    _a['grid.filterAndLogic'] = 'And',
    _a['grid.filterOrLogic'] = 'Or',
    _a);
/**
 * @hidden
 */
function pagerMessagesMap(pagerMessageKey) {
    var messageKey = pagerMessageKey.replace(/^pager\.([a-z])/, function (_match, group) { return 'grid.pager' + group.toUpperCase(); });
    return ({ messageKey: messageKey, defaultMessage: exports.messages[messageKey] });
}
exports.pagerMessagesMap = pagerMessagesMap;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-grid@3.18.0_v4dt5gqvzldvli3cocmcghfwh4/~/@progress/kendo-react-grid/dist/npm/messages/index.js
// module id = 60
// module chunks = 0